/**
 * @fileoverview Router configuration for questionnaire management
 * This module defines the routes for listing, viewing, and editing questionnaires
 */

// Dynamic imports for code splitting and lazy loading
const QuestionnaireList = () => import('@/views/questionnaires/QuestionnaireList.vue')
const QuestionnaireView = () => import('@/views/questionnaires/QuestionnaireView.vue')
const QuestionnaireForm = () => import('@/views/questionnaires/QuestionnaireForm.vue')

/**
 * Routes for questionnaire management
 * All routes require authentication and have appropriate titles for browser tabs
 *
 * Routes:
 * - /questionnaires: List all questionnaires
 * - /questionnaires/:id: View a specific questionnaire
 * - /questionnaires/:id/edit: Edit a specific questionnaire
 */
export const questionnaireRoutes = [
  {
    path: '/questionnaires',
    name: 'Questionnaires',
    component: QuestionnaireList,
    meta: {
      requiresAuth: true,
      title: 'Questionnaires'
    }
  },
  {
    path: '/questionnaires/new',
    name: 'NewQuestionnaire',
    component: QuestionnaireForm,
    meta: {
      requiresAuth: true,
      title: 'New Questionnaire'
    }
  },
  {
    path: '/questionnaires/:id',
    name: 'ViewQuestionnaire',
    component: QuestionnaireView,
    meta: {
      requiresAuth: true,
      title: 'View Questionnaire'
    }
  },
  {
    path: '/questionnaires/:id/edit',
    name: 'EditQuestionnaire',
    component: QuestionnaireForm,
    meta: {
      requiresAuth: true,
      title: 'Edit Questionnaire'
    }
  }
]
